/*
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2020-04-16 17:55:22
 * @LastEditors: 侯鹏许(houpengxu@qq.com)
 * @LastEditTime: 2020-04-16 22:26:16
 * @Description: 绑定如是创建页面，产生销售线索。
 * config.js 里面需要配置
       apiRushiH5Platform: {
        protocol: "http:",
        domain: "qmyx.ttrushi.com",
      },
      httpRushiH5Platform: null,
      servicesRushiH5jssdk: {
        pageid: 150279,
        psn: "7cb32ae349724ee19f9d41abc48ce23e",
        projectid: 61,
        saleslead: {
          browse: true,
          share: true,
          leavePhone: true
        }
      }
 * 
 * 
 * 1、一打开页面就提交浏览信息
 * 2、分享回调加上
 * this.$rsh5.actShare();
 * 3、留电的时候调用下
 * this.$rsh5.actEntry(strPhone);
 */

import httprsh5 from "@/http/rushi-h5-platform"
import apirsh5 from "@/api/rushi-h5-platform";
import util from '@/utils/common';
let _options = {
  pageid: 0,
  psn: "",
  projectid: 0,
  openid: "",
  refereeopenid: "",
  tempid: "",
  channelid: 0,
  saleslead: {
    browse: true,
    share: true,
    leavePhone: true
  }
};
function init(obj) {
  Object.assign(_options, obj);
  if (_options.saleslead.share == true || _options.saleslead.leavePhone == true) {
    _options.saleslead.browse = true;//分享和留电销售线索推送必须要有浏览
  }
  if (_options.saleslead.browse) {
    _options.tempid = util.getGuid();
    // setTimeout(function () {
    //   actIp();
    //   setInterval(function () {
    //     actIp();
    //   }, 3000);
    // }, 1000);
  }
}
// function actIp() {
//   if (_options.saleslead.browse) {
//     httprsh5.post(apirsh5.action.actIp, {
//       openid: _options.openid,
//       pageid: _options.pageid,
//       refereeopenid: _options.refereeopenid,
//       projectid: _options.projectid,
//       psn: _options.psn,
//       tempid: _options.tempid
//     });
//   }
// }

function actShare() {
  if (_options.saleslead.share) {
    httprsh5.post(apirsh5.action.actShare, {
      openid: _options.openid,
      pageid: _options.pageid,
      refereeopenid: _options.refereeopenid,
      psn: _options.psn,
    });
  }
}

function actEntry(strPhone) {
  if (_options.saleslead.leavePhone) {
    httprsh5.post(apirsh5.action.actEntry, {
      phone: strPhone,
      pageid: _options.pageid,
      channelid: _options.channelid,
      refereeopenid: _options.refereeopenid,
      openid: _options.openid
    });
  }
}



export default {
  options: _options,
  init,
  actShare,
  actEntry
}